module.exports = __webpack_public_path__ + "img/anna02.7cbf8f88.jpg";